import React from "react"
import Container from "../global/forLayout/container"
import Video from "./forVideo/video"
import styled from "styled-components"

const SecondSection = () => {
  return (
    <Container>
      <Video
        tagline="Just Do It"
        coolQuote="Show them what crazy dreams can do"
        src={`https://www.youtube.com/embed/hOVkEHADCg4?modestbranding=1&showinfo=0&controls=0`}
      />
    </Container>
  )
}

export default SecondSection
